/**
 * The default SCM hostname to use.
 */
export const DEFAULT_SCM_HOST = 'github.com';

/**
 * GitHub Enterprise cloud username prefix
 */
export const GHEC_USER_SUFFIX = '_comcast';

/**
 * GitHub Enterprise environment name
 */
export const DEFAULT_GITHUB_ENV = 'cloud';
/**
 * Mapping a custom label to scm host
 */
export const GITHUB_LABEL_MAPPING = new Map<string, string>([
  [DEFAULT_SCM_HOST, 'Github Enterprise Cloud'],
]);

/**
 * List of available tiers for devices
 */
export const DEVICE_TIER_LIST = [
  'CI',
  'Development',
  'DR',
  'Integration',
  'MIT',
  'PreProd',
  'Production',
  'QA',
  'Staging',
  'Training',
];

/**
 * List of available environments for devices
 */
export const DEVICE_ENVIRONMENT_LIST = [
  'App',
  'CTRLPlain',
  'DB',
  'ESXi',
  'Gateway',
  'Loadbal',
  'Messaging',
  'MSGQueue',
  'Network',
  'Poller',
  'Reporting',
  'Runtime',
  'Security',
  'Storage',
  'Web',
];

/**
 * Enum constants for Google Click ID
 */
export enum GoogleClickId {
  WORKLISTITEM = 'worklistItem',
}

/**
 * Authentication type Passport
 */
export const AUTH_TYPE_PASSPORT = 'passport';

/**
 * Authentication type Azure AD
 */
export const AUTH_TYPE_AZURE_AD = 'azure';
